module.exports = __webpack_public_path__ + "static/index/img/baikal-101.c5ac770e.jpg";